export default __webpack_public_path__ + "static/media/012-sock.6eb1f04e.svg";